import { tsUtils } from '@neo-one/ts-utils';
import { BuiltinInstanceMemberCall } from '../../BuiltinInstanceMemberCall';
export class AccountGetBalance extends BuiltinInstanceMemberCall {
    canCall(_sb, _func, node) {
        return tsUtils.argumented.getArguments(node).length === 1;
    }
    emitCall(sb, func, node, optionsIn, visited) {
        const options = sb.pushValueOptions(optionsIn);
        if (!visited) {
            sb.visit(tsUtils.expression.getExpression(func), options);
        }
        if (tsUtils.argumented.getArguments(node).length < 1) {
            return;
        }
        sb.emitHelper(node, options, sb.helpers.unwrapBuffer);
        sb.visit(tsUtils.argumented.getArguments(node)[0], options);
        sb.emitHelper(tsUtils.argumented.getArguments(node)[0], options, sb.helpers.unwrapBuffer);
        sb.emitOp(node, 'SWAP');
        sb.emitSysCall(node, 'Neo.Account.GetBalance');
        if (optionsIn.pushValue) {
            sb.emitHelper(node, options, sb.helpers.wrapNumber);
        }
        else {
            sb.emitOp(node, 'DROP');
        }
    }
}

//# sourceMappingURL=getBalance.js.map
